import { render, staticRenderFns } from "./SurveysView.vue?vue&type=template&id=4161f53b&scoped=true&"
import script from "./SurveysView.vue?vue&type=script&lang=js&"
export * from "./SurveysView.vue?vue&type=script&lang=js&"
import style0 from "./SurveysView.vue?vue&type=style&index=0&id=4161f53b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4161f53b",
  null
  
)

export default component.exports